const Benefits = () => {
  const benefits = [
    {
      icon: 'ri-alarm-warning-line',
      title: '24/7 Emergency Response',
      desc: 'Drainage emergencies don\'t keep office hours. Our engineers are on call around the clock, 365 days a year — including bank holidays.',
    },
    {
      icon: 'ri-camera-3-line',
      title: 'Annual CCTV Survey',
      desc: 'We inspect your entire drainage system with high-definition CCTV cameras every year, catching problems before they become expensive disasters.',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'No Callout Charges',
      desc: 'As a plan member, you\'ll never pay a callout fee. We come to you whenever you need us — no surprise bills, ever.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Parts & Labour Covered',
      desc: 'From drain jetting to pipe repairs, parts and labour are included up to claim limits. One monthly payment, no surprise bills.',
    },
    {
      icon: 'ri-time-line',
      title: 'Priority Response Time',
      desc: 'Plan members are always moved to the front of the queue. When you call, we prioritise your job over standard bookings.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fully Insured Engineers',
      desc: 'All our engineers are fully qualified, DBS checked, and carry comprehensive public liability insurance for your complete peace of mind.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Detailed Service Reports',
      desc: 'After every visit, you receive a full written report with photos and recommendations — perfect for landlords and property managers.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Dedicated Support Line',
      desc: 'Plan members get access to a dedicated customer support line with shorter wait times and a team that knows your property history.',
    },
  ];

  return (
    <section id="benefits" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-orange-400 text-xs font-bold uppercase tracking-widest">Comprehensive Protection</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mt-3 mb-5">
            What's Included In Your Plan
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Every maintenance plan comes packed with benefits designed to keep your drains flowing and your property protected all year long.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-gray-800 rounded-2xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform border border-gray-700/50 hover:border-orange-500/30 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 rounded-xl group-hover:bg-orange-500/20 transition-colors">
                <i className={`${benefit.icon} text-2xl text-orange-400`}></i>
              </div>
              <h3 className="text-white font-bold text-base leading-snug">{benefit.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{benefit.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-gray-800 border border-gray-700 rounded-2xl px-8 py-6">
            <div className="text-left">
              <div className="text-white font-bold text-lg">Ready to protect your property?</div>
              <div className="text-gray-400 text-sm mt-1">Join 500+ homeowners already covered. UK Mainland only — South &amp; South West England.</div>
            </div>
            <button
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm px-8 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              View Pricing Plans
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
